export default {
  HIDE: '@WS_EDITOR/HIGHLIGHTER/HIDE',
  SHOW: '@WS_EDITOR/HIGHLIGHTER/SHOW',
  HIDE_HOVERED: '@WS_EDITOR/HIGHLIGHTER/HIDE_HOVERED',
  HIDE_ANCHOR_HIGHLIGHTERS: '@WS_EDITOR/HIGHLIGHTER/HIDE_ANCHOR_HIGHLIGHTERS',
  SHOW_ANCHOR_HIGHLIGHTERS: '@WS_EDITOR/HIGHLIGHTER/SHOW_ANCHOR_HIGHLIGHTERS',
};
